import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { useModal } from '@shared/lib';
import { useScrollDirection } from '@shared/lib/browser';
import { usePartner } from '@shared/lib/partner';
import { getMobileNavbarItemsByPartner, keysNavbarItem, moreNavbarItem, newsNavbarItem, steamNavbarItem } from '../config/navbarItems';
import MobileNavbarButton from './MobileNavbarButtonTest';
import { useActiveNavbarElement } from '../lib/useActiveNavbarElement';
import MoreModal from './MoreModal';
import { NavbarItemType } from '../model/navbar.model';
const MobileNavbar: FC = () => {
  const activeNavbarElement = useActiveNavbarElement();
  const {
    partner
  } = usePartner();
  const moreModalParams = useModal();
  const {
    scrollDirection,
    isAtTop
  } = useScrollDirection();
  const isSteamActive = activeNavbarElement?.href === steamNavbarItem?.href;
  const isHidden = isSteamActive && scrollDirection === 'down' && !isAtTop;
  const checkIsNavbarElementActive = (item: NavbarItemType) => {
    if (item.label === moreNavbarItem?.label) {
      return activeNavbarElement?.label === newsNavbarItem?.label || activeNavbarElement?.label === keysNavbarItem?.label;
    }
    return item.href === activeNavbarElement?.href;
  };
  const getModalHandlers = (item: NavbarItemType) => {
    if (item.label === moreNavbarItem?.label) return moreModalParams;
    return null;
  };
  return <>
      <MobileNavbarWrapper isHidden={isHidden}>
        <NavButtonsWrapper>
          {getMobileNavbarItemsByPartner(partner).map(item => <MobileNavbarButton key={item.label} isActive={checkIsNavbarElementActive(item)} item={{
          ...item,
          onClick: getModalHandlers(item)?.handleModalOpen
        }} />)}
        </NavButtonsWrapper>
      </MobileNavbarWrapper>
      <MoreModal open={moreModalParams.isModalActive} onClose={moreModalParams.handleModalClose} />
    </>;
};
export default MobileNavbar;
interface MobileNavbarWrapperProps {
  isHidden: boolean;
}
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.stroke.default;
const _exp3 = /*#__PURE__*/() => ({
  isHidden
}) => isHidden ? 'translateY(100%)' : 'translateY(0)';
const _exp4 = /*#__PURE__*/() => ({
  isHidden
}) => isHidden ? 'none' : 'auto';
const MobileNavbarWrapper = withTheme(/*#__PURE__*/styled('nav')({
  name: "MobileNavbarWrapper",
  class: "mn38j1k",
  propsAsIs: false,
  vars: {
    "mn38j1k-0": [_exp()],
    "mn38j1k-1": [_exp2()],
    "mn38j1k-2": [_exp3()],
    "mn38j1k-3": [_exp4()]
  }
}));
const NavButtonsWrapper = /*#__PURE__*/styled('ul')({
  name: "NavButtonsWrapper",
  class: "njxmxu7",
  propsAsIs: false
});

require("./MobileNavbar.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MobileNavbar.tsx");